<template lang="pug">
  .page(v-if="board")
    section
      .max-width
        .breadcrumbs
          ul
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminDashboard' : 'PublicDashboard'}") Dashboard
            li
              span \
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminBoard' : 'PublicBoard', params: { boardSlug: board.slug}}") {{ board.name }}
            li
              span \
            li.selected
              span Settings

    section
      .max-width
        .row
          .col.max
            router-view
          .col
            aside
              .aside-header
                span Board Settings
              nav
                .aside-label.primary-text Settings
                hr
                router-link(:to="{ name: 'BoardSettingsGeneral' }") General
                //- router-link(:to="{ name: 'BoardSettingsForm' }") Form
                router-link(:to="{ name: 'BoardSettingsWidget' }") Widget
                router-link(:to="{ name: 'BoardSettingsImport' }") Import Data
                router-link(:to="{ name: 'BoardSettingsDelete' }") Delete

</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'BoardSettings',
  beforeMount () {
    this.$store.commit('boards/SELECT_BOARD', this.$route.params.boardSlug)
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      board: 'boards/selected',
    }),
    isAdmin () {
      return this.$route.matched[0].meta.member
    },
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped>
  header.settings
    margin-bottom $spacing-2
    h2
      font-weight 500
  nav
    font-size $text-size-small
    .aside-label
      font-weight 600
      padding $spacing-2 $spacing-2
    a
      display block
      padding $spacing-2
      &.router-link-exact-active
        background-color $background-active
    hr
      border none
      border-top $border-default
      margin 0
  aside
    border $border-default
    border-radius $border-radius
    margin-left $spacing-3
    width 370px
    .aside-header
      background-color $background-color
      padding $spacing-4 0
      margin-bottom $spacing-2
      text-align center
</style>
